<template>
	<div v-if="showDeliverModesDropdown">
		<div class="sk-widget-title">Delivery To</div>
		<div class="checkout-subtitle">Choose where you receive your order</div>
		<div class="sk-widget-alt">
			<SkDropdownSelect
				v-model="deliveryMode"
				:options="deliveryModes"
				:classes="'sk-select-alternate'"
				ref="dropdown"
			/>
		</div>
	</div>
</template>

<style scoped>
.sk-widget-title {
	margin-bottom: 0;
}

.sk-widget-alt {
	overflow: visible;
}

.sk-widget-alt .sk-select-alternate {
	height: 55px;
	padding: 0 18px;
}
</style>

<script>
import SkDropdownSelect from "@/components/common/SkDropdownSelect.vue"
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import { BusinessType } from "@reef-os/utils/enums/businessType"

export default {
	name: "CheckoutDeliveryModeSection",
	components: {
		SkDropdownSelect
	},
	filters: {
		deliveryModeFormatter(deliveryMode, businessType) {
			switch (deliveryMode) {
				case DeliveryMode.DIRECT_TO_CUSTOMER: {
					return "Direct to Customer"
				}
				case DeliveryMode.DIRECT_TO_LOCATION: {
					switch (businessType) {
						case BusinessType.HOTEL: {
							return "Room Service"
						}
						case BusinessType.RESIDENTIAL: {
							return "To Apartment"
						}
						case BusinessType.COWORKING: {
							return "To Suite"
						}
						default: {
							return "Table Number"
						}
					}
				}
				case DeliveryMode.PICKUP_AREA: {
					if (businessType == BusinessType.HOTEL) {
						return "Lobby Pickup Area"
					} else {
						return "Pickup Area"
					}
				}
				case DeliveryMode.YAY_FOOD_POLE: {
					return "Yay Food Pole"
				}
				case DeliveryMode.LAST_YARD: {
					return "Directly To Me"
				}
			}
			return ""
		}
	},
	computed: {
		showDeliverModesDropdown() {
			return this.deliveryModes && this.deliveryModes.length > 1
		},
		deliveryModes() {
			if (this.$store.getters.cartDeliveryModes) {
				const businessType = this.$store.state.business
					? this.$store.state.business.type
					: null
				return this.$store.getters.cartDeliveryModes.map(
					(deliveryMode) => {
						return {
							id: deliveryMode.deliveryMode,
							text: this.$options.filters.deliveryModeFormatter(
								deliveryMode.deliveryMode,
								businessType
							)
						}
					}
				)
			}
		},
		deliveryMode: {
			get: function () {
				return this.deliveryModes.find(
					(deliveryModeOption) =>
						deliveryModeOption.id ==
						this.$store.getters.deliveryMode
				)
			},
			set: function (deliveryMode) {
				this.$store.dispatch("setDeliveryMode", deliveryMode.id)
			}
		}
	},
	methods: {}
}
</script>